// Ticks a server-rendered countdown once per second and hides it when the end time passes.
class SCountdown extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.end = Number(this.dataset.end) * 1000;
    this.units = {
      d: this.querySelector('[data-unit="d"]'),
      h: this.querySelector('[data-unit="h"]'),
      m: this.querySelector('[data-unit="m"]'),
      s: this.querySelector('[data-unit="s"]'),
    };
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const remaining = Math.floor((this.end - Date.now()) / 1000);
    if (!Number.isFinite(remaining) || remaining <= 0) {
      window.clearInterval(this.#timer);
      this.hidden = true;
      return;
    }
    const pad = (value) => String(value).padStart(2, '0');
    this.#set('d', String(Math.floor(remaining / 86400)));
    this.#set('h', pad(Math.floor((remaining % 86400) / 3600)));
    this.#set('m', pad(Math.floor((remaining % 3600) / 60)));
    this.#set('s', pad(remaining % 60));
  }

  #set(unit, value) {
    const node = this.units[unit];
    if (node && node.textContent !== value) node.textContent = value;
  }
}

if (!customElements.get('s-countdown')) {
  customElements.define('s-countdown', SCountdown);
}
